export default __webpack_public_path__ + "static/media/kalahastiTemple6.e4658c00.png";